import { render, staticRenderFns } from "./PageEventGiftSent.vue?vue&type=template&id=5c99f033&scoped=true&"
import script from "./PageEventGiftSent.vue?vue&type=script&lang=js&"
export * from "./PageEventGiftSent.vue?vue&type=script&lang=js&"
import style0 from "./PageEventGiftSent.vue?vue&type=style&index=0&id=5c99f033&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99f033",
  null
  
)

export default component.exports